const generateStringSequence = ( times ) => ( char ) =>
    `${char}`.repeat( times ) 

const generateArray = ( length ) => 
Array.from( { length }, ( v, k ) => k )

const sequenceFrom0To9 = generateArray( 10 )
const generateSequenceSize11 = generateStringSequence( 11 )
const CPFS_WITH_SAME_DIGIT = sequenceFrom0To9.map( generateSequenceSize11 )

const isIn = ( list ) => ( value ) => 
list.findIndex( v => value === v ) >= 0

const mod11 = ( num ) => num % 11 

const testDigit = ( num ) => 
( num < 2 )
    ? 0
    : 11 - num

const getCpfToCheck = ( cpf ) => 
( cpf.map )
    ? cpf.slice( 0, 9 )
    : cpf.substr( 0, 9 ).split( '' )
const toSumOfMultiplication = ( total ) => ( result, num, i ) => 
result + ( num * total-- )

const getSumOfMultiplication = ( list, total ) => 
list.reduce( toSumOfMultiplication( total ), 0 )

const getTwoLastDigits = ( cpf ) => `${cpf.charAt( 9 )}${cpf.charAt( 10 )}` 
const mergeDigits = ( num1, num2 ) => `${num1}${num2}`
const isEqual = ( a ) => ( b ) => b === a

export const validate = ( cpfFull ) => {

cpfFull = cpfFull.replace(/\D/g,'')

const cpf = getCpfToCheck( cpfFull )

const firstDigit = testDigit( mod11( getSumOfMultiplication( cpf, 10 ) ) )

const secondDigit = testDigit( mod11( getSumOfMultiplication( cpf.concat( firstDigit ), 11 ) ) )

return !isIn( CPFS_WITH_SAME_DIGIT )( cpfFull ) &&
        isEqual( getTwoLastDigits( cpfFull ) )
    ( mergeDigits( firstDigit, secondDigit ) )
}


// WEBPACK FOOTER //
// ./src/services/cpfService.js